import type { Question } from '../types/assessment';

export type SeverityLevel = 'low' | 'medium' | 'high' | 'critical';

function normalizedMeaning(value?: string): string {
  return (value || '').toLowerCase().trim();
}

export function severityWeight(level?: SeverityLevel, explicitWeight?: number): number {
  if (typeof explicitWeight === 'number') return explicitWeight;
  switch (level) {
    case 'critical':
      return 10;
    case 'high':
      return 6;
    case 'low':
      return 2;
    case 'medium':
    default:
      return 4;
  }
}

export function isNegativeMeaning(value?: string): boolean {
  const meaning = normalizedMeaning(value);
  return (
    meaning.includes('deficient') ||
    meaning.includes('non-compliant') ||
    meaning.includes('bad') ||
    meaning.includes('risk') ||
    meaning.includes('insecure') ||
    meaning.includes('issue') ||
    meaning.includes('finding')
  );
}

export function isPositiveMeaning(value?: string): boolean {
  const meaning = normalizedMeaning(value);
  return (
    meaning.includes('compliant') ||
    meaning.includes('secure') ||
    meaning.includes('good') ||
    meaning.includes('acceptable') ||
    meaning.includes('meets requirement')
  );
}

export function responseCreatesFinding(question: Question | undefined, value: unknown): boolean {
  if (value === null || value === undefined || value === '') return false;

  if (typeof value === 'boolean') {
    const yesIsNegative = isNegativeMeaning(question?.answerMeaning?.yes);
    const noIsNegative = isNegativeMeaning(question?.answerMeaning?.no);
    const yesIsPositive = isPositiveMeaning(question?.answerMeaning?.yes);
    const noIsPositive = isPositiveMeaning(question?.answerMeaning?.no);

    if (yesIsNegative && !noIsNegative) return value === true;
    if (noIsNegative && !yesIsNegative) return value === false;
    if (yesIsPositive && !noIsPositive) return value === false;
    if (noIsPositive && !yesIsPositive) return value === true;
    return value === false;
  }

  if (typeof value === 'string') {
    return value.trim().toLowerCase() === 'no';
  }

  return false;
}
